module.exports = __webpack_public_path__ + "static/img/bg1.ca33f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg1.png
// module id = 447
// module chunks = 1